import { EnvType, RequestType } from "src/interfaces";

export const environment: EnvType = {
  production: process.env.REACT_APP_PROD === "true" ? true : false,
  siteTitle: process.env.REACT_APP_TITLE || "",
  source: process.env.REACT_APP_SOURCE || "",
  apiPath: process.env.REACT_APP_API || "",
  domain: process.env.REACT_APP_DOMAIN || "",
  apiKey: process.env.REACT_APP_KEY || "",
};
